import { PARTNER_PROFILE_STRINGS as S } from './partner-profile.strings';

/**
 * Each partner profile field's on-screen label, for the summary at the top of a panel
 * whose Save was refused (FR-189). Keyed by form field and ordered as the panels lay
 * the fields out.
 */
export const PARTNER_FIELD_LABELS: Readonly<Record<string, string>> = {
  // About
  businessName: S.BUSINESS_NAME,
  contactName: S.CONTACT_NAME,
  contactTitle: S.CONTACT_TITLE,
  phone: S.PHONE,
  websiteUrl: S.WEBSITE,
  schedulingUrl: S.SCHEDULING,
  contactPreference: S.CONTACT_PREFERENCE_LABEL,
  description: S.BIO,
  // Services
  categoryIds: S.SERVICE_CATEGORIES,
  tags: S.SERVICES_OFFERED,
  tagline: S.TAGLINE,
  // Online presence
  inquiryEmail: S.CONTACT_EMAIL_FOR_INQUIRIES,
  linkedinUrl: S.LINKEDIN,
  promoVideoUrl: S.PROMO_VIDEO,
  // Images
  logoFileKey: S.LOGO_LABEL,
  coverPhotoFileKey: S.COVER_PHOTO_LABEL,
  listingCoverFileKey: S.LISTING_COVER_LABEL,
};
